/**
 * Platform Validation Service (ISSUE-165)
 *
 * Validates Krysalis Platform artifacts for Bridge Sessions.
 * Calls GET /api/v1/platform/validate/{company_id} and returns
 * validation status with backend-provided error descriptions.
 */

import { apiClient } from './apiClient';

export interface PlatformValidationError {
  artifact_type: 'platform' | 'subscription' | 'feature';
  artifact_id: string | null;
  error: string;
}

export interface PlatformValidationResult {
  company_id: string;
  validation_status: 'valid' | 'partial' | 'invalid';
  platform_artifact: {
    exists: boolean;
    operational_item_active?: boolean;
    improvement_item_active?: boolean;
    status: string;
    artifact_id?: string;
  };
  subscription_artifacts: Array<{
    artifact_id: string;
    exists: boolean;
    operational_item_active?: boolean;
    improvement_item_active?: boolean;
    status: string;
  }>;
  feature_artifacts: Array<{
    artifact_id?: string;
    prime_artifact_id?: string;
    exists: boolean;
    operational_item_active?: boolean;
    improvement_item_active?: boolean;
    status: string;
  }>;
  errors: PlatformValidationError[];
}

export const platformValidationService = {
  /**
   * Validate platform artifacts for a company.
   * Returns backend validation result with error descriptions for display.
   */
  async validate(companyId: string): Promise<PlatformValidationResult> {
    const response = await apiClient.get<PlatformValidationResult>(
      `/platform/validate/${companyId}`
    );
    return response.data;
  },
};
